import styled from 'styled-components';
const percentageSize = 1.3;

export const SidebarContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'inline-block' : 'none')};

  position: fixed;

  background-color: rgb(51, 51, 51, 0.9);
  height: 100%;
  z-index: 20;
  width: 350px;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  transition: 0.3s ease-in-out;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  font-weight: 200;

  @media screen and (max-width: 768px) {
    width: ${({ width }) => width};
  }
`;

export const SidebarWrapper = styled.div``;

export const SidebarTable = styled.div`
  display: grid;
  grid-template-rows: auto auto auto auto auto;
  width: 100%;
  padding-left: 15px;
`;

export const SidebarRow = styled.div`
  display: flex;
  padding: 10px;
`;

export const SeparatorRow = styled.div`
  content: '';
  background-color: #555;
  position: relative;
  width: 100%;
  height: 1px;
`;

export const SidebarSubTable = styled.div``;

export const SidebarSubRow = styled.div``;

export const GencatLinks = styled.a`
  display: flex;
  color: #eeeeee;
  text-decoration: none;
  margin-bottom: 1rem;
  cursor: pointer;
  display: block;

  &:hover {
    color: #febf00;
    text-decoration: underline;
  }
`;

export const SVGNewTab = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 14 * percentageSize : 14,
  height: props.fontSizeEnabled ? 14 * percentageSize : 14
}))`
  margin-left: 5px;
`;

export const Descripcio = styled.div`
  color: white;
  position: absolute;
  padding-left: 15px;
  padding-right: 15px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  bottom: 70px;

  @media screen and (max-width: 464px) {
    bottom: 100px;
  }
`;
